$(document).ready(function(){
    $('.size-guide-scroll-sec').on('click', function() {
    var offsetTop = $('.size_fit_wrapper').offset().top;
    var offsetAdjustment = 50; 
    $('html, body').animate({
      scrollTop: offsetTop - offsetAdjustment 
    }, 1000); 
  });
//  PDP INFO SIZE VAIANT CHANGE
    var selectedSize = $('.size_pills_options input[name="Size"]:checked').val();
    $('.size_pills_options .guide-size-label').each(function () {
        if ($(this).data('label') === selectedSize) {
            $(this).show();
        } else {
            $(this).hide();
        }
    });
   $('.size_pills_options').find(".selected_size_val").text(selectedSize);

    $('.size_pills_options input[name="Size"]').change(function () {
        var selectedSize = $('.size_pills_options input[name="Size"]:checked').val();
        $('.size_pills_options .guide-size-label').each(function () {
            if ($(this).data('label') === selectedSize) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });
      $('.size_pills_options').find(".selected_size_val").text(selectedSize);
    });
//Model Variant Change
     var selectedSize = $('.size_pills_options input[name="Model"]:checked').val();
   $('.size_pills_options').find(".selected_size_val").text(selectedSize);

    $('.size_pills_options input[name="Model"]').change(function () {
        var selectedSize = $('.size_pills_options input[name="Model"]:checked').val();
      $('.size_pills_options').find(".selected_size_val").text(selectedSize);
    });
// Model variant change END
 
//  PDP INFO SIZE VAIANT CHANGE END 
  
  //  PDP STICKY INFO SIZE VAIANT CHANGE
         var selectedSize = $('.sticky_size_pills_options input[name="Size"]:checked').val();
    $('.sticky_size_pills_options .guide-size-label').each(function () {
        if ($(this).data('label') === selectedSize) {
            $(this).show();
        } else {
            $("this").hide();
        }
    });
    $('.sticky_size_pills_options').find(".selected_size_val").text(selectedSize);

    $('.sticky_size_pills_options input[name="Size"]').change(function () {
        var selectedSize = $('.sticky_size_pills_options input[name="Size"]:checked').val();
        $('.sticky_size_pills_options .guide-size-label').each(function () {
            if ($(this).data('label') === selectedSize) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });
       $('.sticky_size_pills_options').find(".selected_size_val").text(selectedSize);
    });

  // Sticky MOdel changes START
       var selectedSize = $('.sticky_size_pills_options input[name="Model"]:checked').val();
    $('.sticky_size_pills_options').find(".selected_size_val").text(selectedSize);

    $('.sticky_size_pills_options input[name="Model"]').change(function () {
        var selectedSize = $('.sticky_size_pills_options input[name="Model"]:checked').val();
       $('.sticky_size_pills_options').find(".selected_size_val").text(selectedSize);
    });
  // Stikcy Mode changes END
  //  PDP STICKY INFO SIZE VAIANT CHANGE END
if($(window).width() <768){
$('.collection-with-ajax-normal .product-grid,.collection-with-ajax .product-grid').on( 'pointerMove.flickity', function( event, pointer, moveVector ) {
   $('body').css('overflow','hidden');
  
});
$('.collection-with-ajax-normal .product-grid,.collection-with-ajax .product-grid').on( 'settle.flickity', function( event, pointer, moveVector ) {
   $('body').css('overflow','scroll');
});
$('.collection-with-ajax-normal .product-grid,.collection-with-ajax .product-grid').on( 'dragEnd.flickity', function( event ) {
   $('body').css('overflow','scroll');
});

$(window).scroll(function() {
   $('.collection-with-ajax-normal .product-grid,.collection-with-ajax .product-grid').flickity(function(){
   draggable: false
   })
    clearTimeout($.data(this, 'scrollTimer'));
    $.data(this, 'scrollTimer', setTimeout(function() {
        // do something
        $('.collection-with-ajax-normal .product-grid,.collection-with-ajax .product-grid').flickity(function(){
         draggable: true
         })
    }, 150));
});
}

var timeFlickity = setInterval(checkflickity,1000);
function checkflickity(params) {
   if($('.collection-with-ajax-normal .product-grid.flickity-enabled.is-draggable,.collection-with-ajax .product-grid.flickity-enabled.is-draggable').length >0){
    window.dispatchEvent(new Event('resize'));
       clearInterval(timeFlickity);
       console.log('clearinterval')
   }
}
 })
